export const DATABASE_NAME = 'myDB'